import alwaysOnOperationIcon from '../../../public/svg/icons/whyUseSmartContracts/alwaysOnOperation.svg';
import automationIcon from '../../../public/svg/icons/whyUseSmartContracts/automation.svg';
import costReductionIcon from '../../../public/svg/icons/whyUseSmartContracts/costReduction.svg';
import globalReachIcon from '../../../public/svg/icons/whyUseSmartContracts/globalReach.svg';
import trustIcon from '../../../public/svg/icons/whyUseSmartContracts/trust.svg';

export const whyUseSmartContractsData = {
  mainText: `Why Smart Contracts Transform Businesses`,
  description: ``,
  services: [
    {
      title: 'Automation',
      description: 'Eliminate manual processes and human error',
      img: automationIcon,
    },
    {
      title: 'Trust',
      description: 'Transparent, immutable business logic',
      img: trustIcon,
    },
    {
      title: 'Cost Reduction',
      description: 'Remove intermediaries and reduce overhead',
      img: costReductionIcon,
    },
    {
      title: 'Global Reach',
      description: 'Borderless operations and payments',
      img: globalReachIcon,
    },
    {
      title: '24/7 Operation',
      description: 'Always-on business logic that never sleeps',
      img: alwaysOnOperationIcon,
    },
  ],
};
